import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import LocalizedText from '@LocalizedText';

import './NavTabElement.scss';

const NavTabElement = ({ id, locKey, active, hidden = false }) => {
  return (
    <div key={id} id={id} data-testid='nav-tab-el' className={classnames('nav-tab-el', { active: active, hidden })}>
      <LocalizedText id={locKey} />
    </div>
  );
};

NavTabElement.propTypes = {
  id: PropTypes.string.isRequired,
  locKey: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  hidden: PropTypes.bool,
};

export default NavTabElement;
